/**************************************************
 * Nombre:       Dialogo_Producto_Valores
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Button, Grid} from "@mui/material";
import {useFormulario} from "../../../Modulo_formularios/Hooks/useFormulario";
import logo from '../../../Recursos/logo_redondo.svg'
import {guardarDoc} from "../../../Servicios/BD/guardarDoc";
import {subirImagenHostingFile} from "../../../Servicios/AlmacenamientoHosting/subirImagenHostingFile";
import {Delete} from "@mui/icons-material";
import {borrarDoc} from "../../../Servicios/BD/borrarDoc";
import {useCargador} from "../../../Modulo_Cargador/Hooks/useCargador";
import {useEffect} from "react";
import {guardarFechaAct} from "../../../Servicios/BD/Actualizadores/guardarFechaAct";
import Formulario_Catalogo_Valores from "../../Formularios/Catalogo/Formulario_Catalogo_Valores";

const Dialogo_Producto_Valores = ({datos, cerrar, realizado}) => {
    const {props, obtenerEntidad} = useFormulario({valoresDefecto: datos})
    const {Avisos, Cargador, nuevoAviso, terminar, iniciarCarga} = useCargador({
        logoRedondo: logo,
        funcionUno: realizado,
        funcionDos: cerrar
    })


    const subirDatos = async () => {

        let entidad = await obtenerEntidad()

        iniciarCarga('Subiendo Datos')
        entidad.fecha = new Date().getTime()
        entidad.prioridad = parseInt(entidad.prioridad)
        let resultado = await subirImagenHostingFile(entidad.img)
        entidad.img = resultado.data
        nuevoAviso({aviso: 'Imagen subida'})


        let dox = await guardarDoc('productos', entidad)
        entidad.id = dox.data
        // await guardarRegistro({obj: entidad, coleccion: 'productos', id: dox.data})
        if (dox.res) {
            await guardarFechaAct('productos')
            terminar({aviso: 'Datos subidos con exito'})
        } else {
            terminar({aviso: 'Algo sali mal, por favor intetalo nuevamente', variante: 'error'})
        }


    }

    const borrar = async () => {
        await borrarDoc('productos', datos.id)
        terminar({aviso: 'Producto borrado'})
    }
    useEffect(() => {
        console.log(datos)
    }, [])
    return (
        <Grid
            container
            justifyContent={'flex-start'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}
            sx={{p: 1}}
        >

            <Avisos/>

            <Cargador/>

            <Grid container size={{xs: 12, sm: 12, md: 12}}>
                <Formulario_Catalogo_Valores props={props}/>
            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'center', marginTop: 3}}>
                <Button
                    onClick={() => subirDatos()}
                >Guardar Datos</Button>
            </Grid>

            {datos && datos.id &&
                <Grid container size={{xs: 12, sm: 12, md: 12}}>
                    <Button
                        onClick={() => borrar()}
                        color={'success'} startIcon={<Delete/>} variant={'text'}>
                        Borrar
                    </Button>
                </Grid>
            }


        </Grid>
    )

}
export default Dialogo_Producto_Valores